import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement, useEffect, useState } from 'react'
import styled from 'styled-components'
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import { Stink } from '../Stink'
import { renderToString } from 'react-dom/server'
import { TextWidth } from '../Container'

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`
const Text = styled.div<{ colorMode: 'light' | 'dark' | undefined }>`
  color: var(--text-color);
  font-family: var(--font-serif);
  font-weight: 400;
  line-height: 2.8rem;
  font-size: 1.7rem;
  margin-bottom: 4rem;
  @media only screen and (min-width: 832px) {
    line-height: 3rem;
    font-size: 1.8rem;
  }
  h4,
  h5 {
    font-family: var(--font-source);
    font-weight: 600;
    font-size: 2.4rem;
    line-height: 2.7rem;
    margin-block-end: 1.5rem;
    margin-bottom: 1.5rem;
  }
  color: var(--text-color);
  font-family: var(--font-serif);
  font-weight: 400;
  line-height: 2.8rem;
  font-size: 1.7rem;
  margin-bottom: 4rem;
  @media only screen and (min-width: 832px) {
    line-height: 3rem;
    font-size: 1.8rem;
  }
  h4,
  h5 {
    font-family: var(--font-source);
    font-weight: 600;
    font-size: 2.4rem;
    line-height: 2.7rem;
    margin-block-end: 1.5rem;
    margin-bottom: 1.5rem;
  }
  a {
    text-decoration: none;
    background-image: ${({ colorMode }) =>
      colorMode === 'light'
        ? 'linear-gradient(90deg, #ffe462, #ffe462)'
        : 'linear-gradient(90deg, #9698A8, #9698A8)'};
    background-repeat: repeat-x;
    background-position: bottom;
    background-size: 100% 20%;
    transition: all 0.1s ease-in-out;
    color: inherit !important;
    background-origin: content-box;
    &:hover {
      background-size: 100% 100%;
    }
    .linkicon {
      rect {
        fill: var(--text-color);
      }
    }
  }
`

const MainComponent: FC<DynamicTextProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const defaultProperties = {
    bfsIdParamName: 'gemeinde',
    geostarAPIUrl: 'https://atm.tamedia.ch/api/geostar/v1/articles/9/',
  }

  const propertiesWithDefaults = { ...defaultProperties, ...properties }
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]

  interface GeostarResponse {
    content: string
    heading: string
    lead: string
    teaser_image_url: string
    title: string
  }

  const [dynamicText, setDynamicText] = useState<string | undefined>()
  const [currentGde, setcurrentGdeNr] = useState<string | number>()

  useEffect(() => {
    const handleEvent = (event: CustomEvent) => {
      setcurrentGdeNr(event.detail)
    }

    window.addEventListener('changeGDE', handleEvent)
    return () => {
      window.removeEventListener('changeGDE', handleEvent)
    }
  }, [])

  useEffect(() => {
    // GET PARAMS FROM URL

    const searchParams = new URL(String(window.location)).searchParams
    const muniParam = searchParams.get(propertiesWithDefaults.bfsIdParamName!)
    const bfsIdFromUrl = muniParam && parseInt(muniParam)
    setcurrentGdeNr(bfsIdFromUrl)
  }, [])

  useEffect(() => {
    if (propertiesWithDefaults?.geostarAPIUrl && currentGde && tenant) {
      let apicall =
        propertiesWithDefaults.geostarAPIUrl +
        currentGde +
        '?tenant=' +
        tenant.key
      fetch(apicall)
        .then((response) => response.json())
        .then((data: GeostarResponse) => {
          setDynamicText(
            data.content || (properties && properties.fallbackContent)
          )
        })
    }
  }, [currentGde])

  const exchangeLinks = (txt: string) => {
    const doc = new DOMParser().parseFromString(txt, 'text/html')
    const links = Array.from(doc.getElementsByTagName('a'), (element) => [
      element.outerHTML,
      element.innerHTML,
      element.getAttribute('href'),
    ])

    links?.map((m) => {
      const href = m[2]
      const text = m[1]
      if (href && text && tenant) {
        txt = txt.replace(
          m[0],
          renderToString(
            <Stink href={href} colorMode={colorMode}>
              {text}
            </Stink>
          )
        )
      }
    })
    return txt
  }

  return (
    <Wrapper className={globalClasses.join(' ')}>
      {dynamicText && (
        <TextWidth>
          <Text
            colorMode={colorMode}
            dangerouslySetInnerHTML={{
              __html: exchangeLinks(dynamicText),
            }}
          ></Text>
        </TextWidth>
      )}
    </Wrapper>
  )
}
export default MainComponent
